import {
  Text,
  Button,
  IconChevronLeft,
  IconChevronRight,
  GreyGrey20,
  GreyGrey30,
  GreyGrey80,
  Primary13SemiBold,
  Flex
} from '@sequencehq/core-components'
import { FC, useState } from 'react'
import { DebugModeItem } from './DebugModeItem'
import { FpsItem } from './FpsItem'
import { MemoryItem } from './MemoryItem'
import { QueryCacheItem } from './QueryCacheItem'
import {
  COLLAPSED_WIDTH,
  EXPANDED_WIDTH
} from './performanceMonitorBar.constants'

export const PerformanceMonitorBar: FC = () => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <Flex
      data-testid="performance-monitor-bar"
      position="relative"
      flexShrink={0}
      width={isExpanded ? EXPANDED_WIDTH : COLLAPSED_WIDTH}
      height="100vh"
      backgroundColor={GreyGrey20}
      borderRight={`1px solid ${GreyGrey30}`}
      flexDirection="column"
      alignItems="stretch"
      paddingY="16px"
      gap="20px"
      transition="width 120ms ease"
      zIndex={2}
      overflowY="auto"
      overflowX="hidden"
    >
      <Flex
        alignItems="center"
        justifyContent={isExpanded ? 'space-between' : 'center'}
        paddingX={isExpanded ? '12px' : '0'}
        flexShrink={0}
      >
        {isExpanded && (
          <Text {...Primary13SemiBold} color={GreyGrey80}>
            Sequence dev tools
          </Text>
        )}
        <Button
          data-testid="performance-monitor-bar.expandToggle"
          aria-label={
            isExpanded ? 'Collapse performance bar' : 'Expand performance bar'
          }
          size="24px"
          variant="ghost"
          style={{ minWidth: '24px', height: '24px' }}
          onClick={() => setIsExpanded(prev => !prev)}
          icon={
            isExpanded ? (
              <IconChevronLeft size={14} />
            ) : (
              <IconChevronRight size={14} />
            )
          }
        />
      </Flex>
      <MemoryItem isExpanded={isExpanded} />
      <QueryCacheItem isExpanded={isExpanded} />
      <FpsItem isExpanded={isExpanded} />
      <DebugModeItem isExpanded={isExpanded} />
    </Flex>
  )
}
